export default __webpack_public_path__ + "static/media/unreal.ce1380de.svg";